module.exports = __webpack_public_path__ + "media/images/group_insurances/banner-ed71e8e6b75ea8132c93a62e5754edd6.jpg";